import { FC, PropsWithChildren } from 'react';
import './DashboardTableFirstColumn.scss';

export const DashboardTableFirstColumn: FC<PropsWithChildren> = ({ children }) => {
  return <div className="DashboardTableFirstColumn">{children}</div>;
};
